const mutations = {
	['UPDATE_APP_INFO'] (state, appInfo) {
		state.pageBackgroundColor = appInfo.pageBackgroundColor;
		state.cardBackgroundColor = appInfo.cardBackgroundColor;
		state.hignlightBorderColor = appInfo.hignlightBorderColor;
		state.cardBtnBackgroundColor = appInfo.cardBtnBackgroundColor;
		state.primaryBtnBackgroundColor = appInfo.primaryBtnBackgroundColor;
		state.virtualCurrencyUnit = appInfo.virtualCurrencyUnit;
	},
};

export default mutations;